import { css } from 'styled-components';

export const commonCssVars = css`
    --yat_emoji-picker-common-color: ${({ theme }) => theme.shades.black[90]};
`;

export const commonCssVarsDark = css`
    --yat_emoji-picker-common-color: ${({ theme }) => theme.shades.white[80]};
`;

export const navCssVars = css`
    --yat_emoji-picker-nav-action-bg-color: transparent;
    --yat_emoji-picker-nav-action-bg-color-hover: ${({ theme }) => theme.shades.black[5]};
    --yat_emoji-picker-nav-action-bg-color-active: ${({ theme }) => theme.shades.black[10]};
    --yat_emoji-picker-nav-action-bg-color-pressed: ${({ theme }) => theme.colors.purple};

    --yat_emoji-picker-nav-icon-color: ${({ theme }) => theme.shades.black[55]};
    --yat_emoji-picker-nav-icon-color-pressed: ${({ theme }) => theme.shades.white[100]};
`;

export const navCssVarsDark = css`
    --yat_emoji-picker-nav-action-bg-color: transparent;
    --yat_emoji-picker-nav-action-bg-color-hover: ${({ theme }) => theme.shades.white[10]};
    --yat_emoji-picker-nav-action-bg-color-active: ${({ theme }) => theme.shades.white[15]};
    --yat_emoji-picker-nav-action-bg-color-pressed: ${({ theme }) => theme.colors.purple};

    --yat_emoji-picker-nav-icon-color: ${({ theme }) => theme.shades.white[50]};
    --yat_emoji-picker-nav-icon-color-pressed: ${({ theme }) => theme.shades.white[100]};
`;
